// Reusable SVG <linearGradient> definitions for billet temperature.
// Placed inside the parent <defs/> block of the main visualizer <svg>.
// IDs match TEMP_GRADIENT_IDS in utils/tempToColor.ts.

import { TEMP_GRADIENT_IDS } from "../utils/tempToColor";

// Each gradient runs top→bottom: the top is the "skin" (cooler, more orange)
// and the bottom is the "core" (deeper red). Gives the billet a 3D feel
// without filters, which is cheap to render.
export const TempGradients = () => (
	<>
		<linearGradient
			id={TEMP_GRADIENT_IDS.cool}
			x1="0%"
			y1="0%"
			x2="0%"
			y2="100%"
		>
			<stop offset="0%" stopColor="#fcd34d" />
			<stop offset="100%" stopColor="#b45309" />
		</linearGradient>

		<linearGradient
			id={TEMP_GRADIENT_IDS.warm}
			x1="0%"
			y1="0%"
			x2="0%"
			y2="100%"
		>
			<stop offset="0%" stopColor="#fb923c" />
			<stop offset="100%" stopColor="#9a3412" />
		</linearGradient>

		<linearGradient
			id={TEMP_GRADIENT_IDS.hot}
			x1="0%"
			y1="0%"
			x2="0%"
			y2="100%"
		>
			<stop offset="0%" stopColor="#f97316" />
			<stop offset="100%" stopColor="#7f1d1d" />
		</linearGradient>

		<linearGradient
			id={TEMP_GRADIENT_IDS.incandescent}
			x1="0%"
			y1="0%"
			x2="0%"
			y2="100%"
		>
			<stop offset="0%" stopColor="#fef08a" />
			<stop offset="55%" stopColor="#f97316" />
			<stop offset="100%" stopColor="#7f1d1d" />
		</linearGradient>
	</>
);
